import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('clarityConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('clarityConsent', 'granted');
    window.clarity('consentv2', { ad_storage: 'granted', analytics_storage: 'granted' });
    setShowBanner(false);
  };

  const handleDeny = () => {
    localStorage.setItem('clarityConsent', 'denied');
    window.clarity('consentv2', { ad_storage: 'denied', analytics_storage: 'denied' });
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: '#333',
      color: '#fff',
      padding: '10px',
      textAlign: 'center',
      zIndex: 1000,
    }}>
      <p>We use cookies for analytics. Do you consent?</p>
      <button onClick={handleAccept} style={{ marginRight: '10px' }}>Accept</button>
      <button onClick={handleDeny}>Deny</button>
    </div>
  );
};

export default CookieConsent;
